$(document).on('turbolinks:load', function(){
  const UnusableCharacters = [
    '①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪','⑫','⑬','⑭','⑮','⑯','⑰','⑱','⑲','⑳',
    'Ⅰ','Ⅱ','Ⅲ','Ⅳ','Ⅴ','Ⅵ','Ⅶ','Ⅷ','Ⅸ','Ⅹ','ⅰ','ⅱ','ⅲ','ⅳ','ⅴ','ⅵ','ⅶ','ⅷ','ⅸ','ⅹ',
    '㎜','㎝','㎞','㎎','㎏','㏄','㍉','㌔','㌢','㍍','㌘','㌧','㌃','㌶','㍑','㍗','㌍','㌦','㌣','㌫',
    '№','℡','㏍','㊤','㊥','㊦','㊧','㊨','㈱','㈲','㈹','㍾','㍽','㍼','㍻','≡','∑','∫',
    '纊','鍈','蓜','炻','棈','兊','夋','奛','奣','寬','﨑','嵂','咊','咩','哿','喆','坙','坥','垬','埈'
  ];

  const ORDER_HISTORY_DELIVERY_DESTINATION_REQUIRED_SELECTORS = [
    '#destination_abbreviation',
    '#destination_name',
    '#destination_zip1',
    '#destination_zip2',
    '#destination_address1',
    '#destination_address2',
    '#destination_tel1',
    '#destination_tel2',
    '#destination_tel3'
  ];

  const ORDER_HISTORY_DELIVERY_DESTINATION_FAX_SELECTORS = [
    '#destination_fax1',
    '#destination_fax2',
    '#destination_fax3'
  ];

  const ORDER_HISTORY_DELIVERY_DESTINATION_NUMERIC_SELECTORS = [
    '#destination_zip1',
    '#destination_zip2',
    '#destination_tel1',
    '#destination_tel2',
    '#destination_tel3',
    '#destination_fax1',
    '#destination_fax2',
    '#destination_fax3'
  ];

  const ORDER_HISTORY_DELIVERY_DESTINATION_FULLWIDTH_SELECTORS = [
    '#destination_name',
    '#destination_address1',
    '#destination_address2',
    '#destination_address3'
  ];

  const ORDER_HISTORY_DELIVERY_DESTINATION_FIELD_RULES = [
    { selector: '#destination_abbreviation', maxLength: 20, required: true },
    { selector: '#destination_name', maxLength: 25, required: true },
    { selector: '#destination_address3', maxLength: 60, required: false }
  ];

  const ORDER_HISTORY_EDIT_DELIVERY_DISABLED_KEYWORDS = ['（お客様引取）', '（その他：特記参照）'];
  const ORDER_HISTORY_EDIT_DELIVERY_DISABLED_CLASS = 'order-history-edit-delivery-disabled';

  const ORDER_HISTORY_DELIVERY_DESTINATION_GROUP_RULES = {
    zip: [
      { selector: '#destination_zip1', maxLength: 3, required: true },
      { selector: '#destination_zip2', maxLength: 4, required: true }
    ],
    address: [
      { selector: '#destination_address1', maxLength: 40, required: true },
      { selector: '#destination_address2', maxLength: 20, required: true }
    ],
    tel: [
      { selector: '#destination_tel1', maxLength: 5, required: true },
      { selector: '#destination_tel2', maxLength: 5, required: true },
      { selector: '#destination_tel3', maxLength: 5, required: true }
    ],
    fax: [
      { selector: '#destination_fax1', maxLength: 5, required: false },
      { selector: '#destination_fax2', maxLength: 5, required: false },
      { selector: '#destination_fax3', maxLength: 5, required: false }
    ]
  };

  var path = document.location.pathname;

  if (path.match(/^\/quotation_order_histories$/)) {
    initializeOrderHistoryListPage();
  }

  if (path.match(/^\/quotation_order_histories\/\d+$/)) {
    initializeOrderHistoryDetailPage();
  }

  if (path.match(/^\/quotation_order_histories\/\d+\/confirm/)) {
    initializeOrderHistoryConfirmPage();
  }

  if (path.match(/^\/quotation_order_histories\/\d+\/complete/)) {
    initializeOrderHistoryCompletePage();
  }

  // ================== 見積注文履歴画面 ==================

  function initializeOrderHistoryListPage(){
    orderHistoryListRestoreBeforeHtml();
    orderHistoryListBindResultButtons();

    // カレンダー
    $('.calender').daterangepicker({
      singleDatePicker: true,
      autoUpdateInput: false
    });
    $('.calender').on('apply.daterangepicker', function(ev, picker) {
      $(this).val(picker.startDate.format('YYYY/MM/DD'));
      orderHistoryListSetValue($(this));
      orderHistoryListRequestSearch();
    });

    $('.quotation_order_status_button input').on('change', function(){
      $(this).val($(this).prop('checked'));
      orderHistoryListRequestSearch();
    });

    $('.input-calender').on('keyup change', function(){
      orderHistoryListRequestSearch();
    });

    var timer = null;
    $('.input-keyword, .input-text').on('input change', function() {
      clearTimeout(timer);

      timer = setTimeout(function() {
        orderHistoryListRequestSearch();
        orderHistoryListSetValue($(this));
      }, 500);
    });

    $('.size-full-code-select').on('change', function(){
      orderHistoryListRequestSearch();
      orderHistoryListSetValue($(this));
      $('#size_full_code_val').val($(this).val());
    });

    $('.user-select').on('change', function(){
      orderHistoryListRequestSearch();
      orderHistoryListSetValue($(this));
      $('#user_id_val').val($(this).val());
    });

    $('#quotation_order_history_query_busho_code').on('change', function(){
      orderHistoryListRequestSearch();
    });
  }

  function orderHistoryListSetValue($target){
    $target.attr('value', $target.val());
  }

  function orderHistoryListRequestSearch(){
    $.ajax({
      url: '/quotation_order_histories/search',
      type: 'post',
      data: {
        quotation_order_history_query:{
          status_requesting: $('#quotation_order_history_query_status_requesting:checked').val(),
          status_ordered: $('#quotation_order_history_query_status_ordered:checked').val(),
          status_order_completed: $('#quotation_order_history_query_status_order_completed:checked').val(),
          order_date_from: $('#quotation_order_history_query_order_date_from').val(),
          order_date_to: $('#quotation_order_history_query_order_date_to').val(),
          preferred_delivery_date_from: $('#quotation_order_history_query_preferred_delivery_date_from').val(),
          preferred_delivery_date_to: $('#quotation_order_history_query_preferred_delivery_date_to').val(),
          quote_expiration_date_from: $('#quotation_order_history_query_quote_expiration_date_from').val(),
          quote_expiration_date_to: $('#quotation_order_history_query_quote_expiration_date_to').val(),
          keyword: $('#quotation_order_history_query_keyword').val(),
          size_full_code: $('.size-full-code-select').val(),
          outer_diameter_min: $('#quotation_order_history_query_outer_diameter_min').val(),
          outer_diameter_max: $('#quotation_order_history_query_outer_diameter_max').val(),
          wall_thickness_min: $('#quotation_order_history_query_wall_thickness_min').val(),
          wall_thickness_max: $('#quotation_order_history_query_wall_thickness_max').val(),
          length_min: $('#quotation_order_history_query_length_min').val(),
          length_max: $('#quotation_order_history_query_length_max').val(),
          user_ids: $('.user-select').val(),
          busho_code: $('#quotation_order_history_query_busho_code').val()
        }
      },
      success: function(json, status, xhr) {
        const contentType = xhr.getResponseHeader('content-type') || '';
        if (contentType.indexOf('html') > -1) {
          alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
          location.href = '/login';
        }
        if (contentType.indexOf('json') > -1) {
          if (json.error) {
            alert(json.error);
            return false;
          }
          $('#search_result').html(json.result);
          orderHistoryListBindResultButtons();
        }
      },
      error: function(xhr, status, e) {
        alert(status);
      }
    });
  }

  function orderHistoryListBindResultButtons(){
    $('.history_show_button, .orderable_button').on('click', function(){
      localStorage.setItem('beforeHistoryHtml', $('.content').html());
    });
  }

  function orderHistoryListRestoreBeforeHtml(){
    var beforeHtml = localStorage.getItem('beforeHistoryHtml');
    var navigationType = null;

    if (typeof window.performance !== 'undefined') {
      if (typeof window.performance.getEntriesByType === 'function') {
        var navigationEntries = window.performance.getEntriesByType('navigation');
        if (navigationEntries && navigationEntries.length > 0) {
          navigationType = navigationEntries[0].type;
        }
      }
      if (navigationType === null && window.performance.navigation) {
        navigationType = window.performance.navigation.type;
      }
    }

    var isBackNavigation = navigationType === 'back_forward' || navigationType === 2;

    if (beforeHtml === null || !isBackNavigation) {
      if (beforeHtml !== null && !isBackNavigation) {
        localStorage.removeItem('beforeHistoryHtml');
      }
      $('.select2').select2({placeholder: '選択してください'});
      return;
    }

    if (beforeHtml !== null){
      $('.content').html(beforeHtml);
      localStorage.removeItem('beforeHistoryHtml');
      code_val = $('#size_full_code_val').val();
      user_id_val = $('#user_id_val').val();
      $('span.select2').remove();
      $('.size-full-code-select').val(code_val).trigger('change.select2');
      $('.size-full-code-select').select2().select2({width: '100%', placeholder: '選択してください'});
      $('.user-select').val(user_id_val).trigger('change.select2');
      $('.user-select').select2().select2({width: '100%', placeholder: '選択してください'});
      $('.quotation_order_status_button input').each(function(){
        ju = $(this).val() == 'true';
        $(this).prop('checked', ju);
      });
    }
  }

  // ================== 見積注文詳細画面 ==================

  function initializeOrderHistoryDetailPage(){
    $('#order_history_back_button').on('click', function(e){
      e.preventDefault();

      var currentUrl = window.location.href;
      var newUrl = currentUrl.replace(/histories\/\d+/g, 'histories');
      window.location.href = newUrl;
    });

    var $additionalToggle = $('#order_history_additional_toggle');
    if ($additionalToggle.length) {
      var $additionalForm = $('#order_history_additional_form');
      var initialDomState = captureAdditionalFormState($additionalForm);

      var pristineDefaults = parseAdditionalFormDefaults($additionalForm.data('pristine-defaults'));
      var pristineAdditionalFormState = buildAdditionalFormStateFromDefaults(pristineDefaults, null) || initialDomState;

      $additionalToggle.on('click', function() {
        var isExpanded = $(this).attr('aria-expanded') === 'true';
        var hasChanges = additionalFormHasChanges($additionalForm, pristineAdditionalFormState);

        if (isExpanded) {
          if (hasChanges) {
            var shouldProceed = window.confirm('ご記入いただいたデータがクリアされますが、続行してよろしいでしょうか？');
            if (!shouldProceed) {
              return;
            }
          }

          // 先に閉じてからリセットする
          $(this).attr('aria-expanded', 'false').text('+');
          $additionalForm.stop(true, true).slideUp(function() {
            if (hasChanges) {
              resetAdditionalForm($additionalForm, pristineAdditionalFormState);
            }
          });
        } else {
          $additionalForm.stop(true, true).slideDown();
          $(this).attr('aria-expanded', 'true').text('-');
        }
      });
    }

    initializeAdditionalNoteControls();
    setupOrderHistoryDocumentButtons();
    orderHistoryUpdateOrderableButtonState();
  }

  // 注文するボタンの非活性処理
  function orderHistoryUpdateOrderableButtonState(){
    var $form = $('#order_history_confirm_form');
    if (!$form.length) {
      return;
    }

    var $button = $form.find('.order_history_orderable_button');
    if (!$button.length) {
      return;
    }

    var shouldDisable = orderHistoryHasInputErrors();
    $button.prop('disabled', shouldDisable);
    $button.toggleClass('button_disabled', shouldDisable);
  }

  // 入力エラーの有無チェック
  function orderHistoryHasInputErrors(){
    var $form = $('#order_history_additional_form');
    if (!$form.length) {
      return false;
    }

    // 通常見積ではお客様使用欄のみが描画されるため、初期チェック対象を限定する
    var isImmediateOrder = $form.find('.order_history_additional_delivery_options').length > 0;

    if (!isImmediateOrder) {
      return $form.find('.order_history_additional_customer_input_error').length > 0 ||
             $form.find('.order_history_additional_customer_error').filter(function(){
               return $(this).text().trim().length > 0;
             }).length > 0;
    }

    if ($form.find('.order_history_additional_delivery_date_input_error').length > 0) {
      return true;
    }

    var hasDeliveryMessage = $form.find('.order_history_additional_delivery_error').filter(function(){
      return $(this).is(':visible') && $(this).text().trim().length > 0;
    }).length > 0;
    if (hasDeliveryMessage) {
      return true;
    }

    if ($form.find('.order_history_additional_note_input_error').length > 0) {
      return true;
    }

    var hasNoteMessage = $form.find('.order_history_additional_note_error').filter(function(){
      return $(this).text().trim().length > 0;
    }).length > 0;
    if (hasNoteMessage) {
      return true;
    }

    if ($form.find('.order_history_additional_customer_input_error').length > 0) {
      return true;
    }

    var hasCustomerMessage = $form.find('.order_history_additional_customer_error').filter(function(){
      return $(this).text().trim().length > 0;
    }).length > 0;

    return hasCustomerMessage;
  }

  function initializeAdditionalNoteControls(){
    initDeliveryDestinationModal();
    initOrderHistorySelectedDestinationDisplay();
    initAdditionalNotes();
    initCustomerUsageFields();

    var $deliveryRadios = $('input[name="order_history_delivery_type"]');
    var $deliveryDateInput = $('#order_history_delivery_date');
    var $deliveryOptions = $('.order_history_additional_delivery_options');
    var $deliveryDateError = $('#order_history_delivery_date_error');
    var $deliveryRow = $deliveryOptions.closest('.order_history_additional_delivery_row');

    if (!$deliveryRadios.length || !$deliveryDateInput.length) {
      return;
    }

    if (typeof $.fn.daterangepicker === 'function' && !$deliveryDateInput.data('daterangepicker')) {
      $deliveryDateInput.daterangepicker({
        minDate: moment().startOf('day'),
        startDate: moment().startOf('day'),
        endDate: moment().startOf('day'),
        singleDatePicker: true,
        autoUpdateInput: false
      });

      $deliveryDateInput.on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY/MM/DD'));
        validateDeliveryDate();
      });

      var dateChangeNamespace = '.orderHistoryDeliveryDate';
      $deliveryDateInput.off('input' + dateChangeNamespace + ' change' + dateChangeNamespace + ' keyup' + dateChangeNamespace)
        .on('input' + dateChangeNamespace + ' change' + dateChangeNamespace + ' keyup' + dateChangeNamespace, function(){
          validateDeliveryDate();
        });
    }

    function toggleDeliveryDateInput(){
      var isScheduled = isDeliveryScheduled();
      $deliveryDateInput.prop('disabled', !isScheduled);

      if (!isScheduled) {
        clearDeliveryDateError();
      } else {
        validateDeliveryDate();
      }
    }

    $deliveryRadios.on('change', toggleDeliveryDateInput);
    toggleDeliveryDateInput();
    validateDeliveryDate();

    function isDeliveryScheduled(){
      return $('#order_history_delivery_scheduled').is(':checked');
    }

    function clearDeliveryDateError(){
      $deliveryDateInput.removeClass('order_history_additional_delivery_date_input_error');
      $deliveryOptions.removeClass('has-error');
      $deliveryRow.removeClass('has-error');
      if ($deliveryDateError.length) {
        $deliveryDateError.text('').hide();
      }
      orderHistoryUpdateOrderableButtonState();
    }

    function showDeliveryDateError(message){
      $deliveryDateInput.addClass('order_history_additional_delivery_date_input_error');
      $deliveryOptions.addClass('has-error');
      $deliveryRow.addClass('has-error');
      if ($deliveryDateError.length) {
        $deliveryDateError.text(message).show();
      }
      orderHistoryUpdateOrderableButtonState();
    }

    function validateDeliveryDate(){
      if (!$deliveryDateInput.length || $deliveryDateInput.is(':disabled')) {
        clearDeliveryDateError();
        return true;
      }

      var value = $deliveryDateInput.val();
      clearDeliveryDateError();

      if (!value) {
        showDeliveryDateError('正しい日付を入力してください');
        return false;
      }

      var format = /^\d{4}\/(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])$/;
      if (!format.test(value)) {
        showDeliveryDateError('正しい形式の日付を入力してください');
        return false;
      }

      var parsed = moment(value, 'YYYY/MM/DD', true);
      if (!parsed.isValid()) {
        showDeliveryDateError('正しい日付を入力してください');
        return false;
      }

      if (parsed.isBefore(moment().startOf('day'))) {
        showDeliveryDateError('過去の日付は入力できません');
        return false;
      }

      return true;
    }
  }

  function initAdditionalNotes(){
    var $notesContainer = $('#order_history_additional_notes');
    var $addButton = $('#order_history_additional_add_note');
    if (!$notesContainer.length || !$addButton.length) {
      return;
    }

    var maxNotes = 6;

    var namespace = '.orderHistoryAdditionalNotes';
    var noteEvents = 'input' + namespace + ' change' + namespace + ' keyup' + namespace;

    $notesContainer.off(noteEvents, '.order_history_additional_note_input');
    $notesContainer.on(noteEvents, '.order_history_additional_note_input', function(){
      orderHistoryValidateAdditionalNoteField($(this));
    });

    toggleAdditionalNoteButtonState();
    updateAdditionalNoteIndices();

    $addButton.off('click' + namespace).on('click' + namespace, function(){
      addAdditionalNoteRow($notesContainer, maxNotes, $addButton);
      toggleAdditionalNoteButtonState();
    });

    $notesContainer.find('.order_history_additional_note_input').each(function(){
      orderHistoryValidateAdditionalNoteField($(this));
    });
  }

  function setupOrderHistoryDocumentButtons(){
    var $downloadButton = $('#order_history_download_button');
    var $printButton = $('#order_history_print_button');
    if (!$downloadButton.length && !$printButton.length) {
      return;
    }

    var unavailableMessage = '見積書発行処理中です。時間をおいてお試しください。';
    var $documentButtons = $downloadButton.add($printButton);
    var isDocumentButtonsWaiting = false;

    function setDocumentButtonsWaiting(isWaiting){
      isDocumentButtonsWaiting = isWaiting;
      if (!$documentButtons.length) {
        return;
      }
      $documentButtons.prop('disabled', isWaiting);
      $documentButtons.toggleClass('order_history_document_button_waiting', isWaiting);
    }

    function requestDocument(orderId){
      if (!orderId) {
        return $.Deferred().reject().promise();
      }
      return $.ajax({
        url: '/quotation_order_histories/' + orderId + '/document_status',
        type: 'GET',
        dataType: 'json'
      });
    }

    $downloadButton.off('click.orderHistoryDocument').on('click.orderHistoryDocument', function(event){
      event.preventDefault();
      if (isDocumentButtonsWaiting) {
        return;
      }
      var orderId = $(this).data('orderId');
      if (!orderId) {
        return;
      }
      setDocumentButtonsWaiting(true);
      requestDocument(orderId)
        .done(function(){
          window.location.href = '/quotation_order_histories/' + orderId + '/download_pdf';
        })
        .fail(function(){
          alert(unavailableMessage);
        })
        .always(function(){
          setDocumentButtonsWaiting(false);
        });
    });

    $printButton.off('click.orderHistoryDocument').on('click.orderHistoryDocument', function(event){
      var $button = $(this);
      if (!$button.length || $button.prop('disabled') || isDocumentButtonsWaiting) {
        return;
      }
      event.preventDefault();
      var orderId = $button.data('orderId');
      if (!orderId) {
        return;
      }
      setDocumentButtonsWaiting(true);
      requestDocument(orderId)
        .done(function(){
          if (typeof printJS === 'function') {
            printJS({
              printable: '/quotation_order_histories/' + orderId + '/print_file',
              showModal: true,
              modalMessage: '印刷準備中です...'
            });
          } else {
            window.open('/quotation_order_histories/' + orderId + '/print_file', '_blank');
          }
        })
        .fail(function(){
          alert(unavailableMessage);
        })
        .always(function(){
          setDocumentButtonsWaiting(false);
        });
    });
  }

  function initCustomerUsageFields(){
    var selectors = ['#order_history_additional_customer_note', '#order_history_additional_customer_note_2'];
    var namespace = '.orderHistoryCustomerUsage';

    selectors.forEach(function(selector){
      var $input = $(selector);
      if (!$input.length) {
        return;
      }

      $input.off('input' + namespace + ' change' + namespace + ' keyup' + namespace)
        .on('input' + namespace + ' change' + namespace + ' keyup' + namespace, function(){
          orderHistoryValidateCustomerUsageField($(this));
        });

      orderHistoryValidateCustomerUsageField($input);
    });
  }

  function addAdditionalNoteRow($container, maxNotes, $addButton){
    var currentCount = $container.find('.order_history_additional_note_row').length;
    if (currentCount >= maxNotes) {
      return;
    }

    var $newRow = $container.find('.order_history_additional_note_row:first').clone();
    $newRow.attr('data-note-index', currentCount + 1);
    $newRow.find('.order_history_additional_note_index').text(getCircledNumber(currentCount + 1));
    $newRow.find('.order_history_additional_note_input')
      .val('')
      .attr('value', '')
      .removeClass('order_history_additional_note_input_error');
    $newRow.find('.order_history_additional_note_error').text('');
    $newRow.find('.order_history_additional_note_button').remove();
    $newRow.find('.order_history_additional_note_button_wrapper').remove();
    // add placeholder to keep layout spacing aligned with first row
    var $placeholderWrapper = $('<div class="order_history_additional_note_button_wrapper order_history_additional_note_button_placeholder">');
    var $placeholderBtn = $('<button type="button" class="order_history_additional_note_button" aria-hidden="true" tabindex="-1" style="visibility: hidden;">+</button>');
    $placeholderWrapper.append($placeholderBtn);

    var $noteField = $newRow.find('.order_history_additional_note_field');
    var $errorWrapper = $noteField.find('.order_history_additional_note_error_wrapper');
    if ($errorWrapper.length) {
      $errorWrapper.before($placeholderWrapper);
    } else {
      $noteField.append($placeholderWrapper);
    }

    $container.append($newRow);
    updateAdditionalNoteIndices();

    var $newInput = $newRow.find('.order_history_additional_note_input');
    if ($newInput.length) {
      orderHistoryValidateAdditionalNoteField($newInput);
    }

    if (currentCount + 1 >= maxNotes) {
      $addButton.prop('disabled', true);
    }

    orderHistoryUpdateOrderableButtonState();
  }

  function applyAdditionalNoteValues(notesValues){
    var $container = $('#order_history_additional_notes');
    var $addButton = $('#order_history_additional_add_note');
    if (!$container.length || !$addButton.length) {
      return;
    }

    var maxNotes = 6;
    var normalizedNotes = Array.isArray(notesValues) ? notesValues.slice(0, maxNotes) : [];
    if (normalizedNotes.length === 0) {
      normalizedNotes = [''];
    }
    normalizedNotes = normalizedNotes.map(function(note){
      return note == null ? '' : note.toString();
    });

    var currentCount = $container.find('.order_history_additional_note_row').length;
    while (currentCount < normalizedNotes.length && currentCount < maxNotes) {
      addAdditionalNoteRow($container, maxNotes, $addButton);
      currentCount++;
    }

    while (currentCount > normalizedNotes.length) {
      $container.find('.order_history_additional_note_row').last().remove();
      currentCount--;
    }

    $container.find('.order_history_additional_note_row').each(function(index){
      var value = normalizedNotes[index] || '';
      var $input = $(this).find('.order_history_additional_note_input');
      $input.val(value).attr('value', value);
      orderHistoryClearAdditionalNoteError($input);
    });

    updateAdditionalNoteIndices();
    toggleAdditionalNoteButtonState();
  }

  // 特記事項のバリデーションチェック
  function orderHistoryValidateAdditionalNoteField($input){
    if (!$input || !$input.length) {
      return;
    }

    var value = $input.val() || '';
    $input.attr('value', value);

    if (!value) {
      orderHistoryClearAdditionalNoteError($input);
      return;
    }

    var noteBytes = orderHistoryCalculateShiftJisBytes(value);
    var exceedsByteLimit = noteBytes > 62;
    var hasUnusableCharacters = orderHistoryIncludeUnusableCharacters(value);

    // 先にバイト数超過を優先的に通知し、解消後に環境依存文字エラーを表示する仕様
    if (exceedsByteLimit) {
      orderHistoryShowAdditionalNoteError($input, '入力した文字が長すぎます。');
      return;
    }

    if (hasUnusableCharacters) {
      orderHistoryShowAdditionalNoteError($input, '入力した文字は使用できません。');
      return;
    }

    orderHistoryClearAdditionalNoteError($input);
  }

  function orderHistoryShowAdditionalNoteError($input, message){
    var $row = $input.closest('.order_history_additional_note_row');
    if (!$row.length) {
      return;
    }

    $input.addClass('order_history_additional_note_input_error');
    $row.addClass('has-error');

    var $labelGroup = $row.closest('#order_history_additional_notes').prev('.order_history_additional_field_label_group');
    if ($labelGroup.length) {
      $labelGroup.addClass('has-error');
    }

    var $errorWrapper = $row.find('.order_history_additional_note_error_wrapper');
    if (!$errorWrapper.length) {
      $errorWrapper = $('<div class="order_history_additional_note_error_wrapper">').appendTo($row);
    }
    var $error = $errorWrapper.find('.order_history_additional_note_error');
    if (!$error.length) {
      $error = $('<span class="order_history_additional_note_error">').appendTo($errorWrapper);
    }
    $error.text(message);
    orderHistoryUpdateOrderableButtonState();
  }

  function orderHistoryClearAdditionalNoteError($input){
    var $row = $input.closest('.order_history_additional_note_row');
    if (!$row.length) {
      return;
    }

    $input.removeClass('order_history_additional_note_input_error');
    $row.removeClass('has-error');
    $row.find('.order_history_additional_note_error').text('');

    var $notesContainer = $row.closest('#order_history_additional_notes');
    if ($notesContainer.length && !$notesContainer.find('.order_history_additional_note_input_error').length) {
      var $labelGroup = $notesContainer.prev('.order_history_additional_field_label_group');
      if ($labelGroup.length) {
        $labelGroup.removeClass('has-error');
      }
    }
    orderHistoryUpdateOrderableButtonState();
  }

  // お客様使用欄の入力チェック
  function orderHistoryValidateCustomerUsageField($input){
    if (!$input || !$input.length) {
      return;
    }

    var value = $input.val() || '';
    $input.attr('value', value);

    if (!value) {
      orderHistoryClearCustomerUsageError($input);
      return;
    }

    var bytes = orderHistoryCalculateShiftJisBytes(value);
    var exceedsByteLimit = bytes > 20;
    var hasUnusableCharacters = orderHistoryIncludeUnusableCharacters(value);

    // 先にバイト数超過を優先的に通知し、解消後に環境依存文字エラーを表示する仕様
    if (exceedsByteLimit) {
      orderHistoryShowCustomerUsageError($input, '入力した文字が長すぎます。');
      return;
    }

    if (hasUnusableCharacters) {
      orderHistoryShowCustomerUsageError($input, '入力した文字は使用できません。');
      return;
    }

    orderHistoryClearCustomerUsageError($input);
  }

  function orderHistoryShowCustomerUsageError($input, message){
    var $wrapper = $input.closest('.order_history_additional_customer_input_wrapper');
    if (!$wrapper.length) {
      return;
    }

    $input.addClass('order_history_additional_customer_input_error');
    var $row = $input.closest('.order_history_additional_customer_row');
    if ($row.length) {
      $row.addClass('has-error');
    }

    var $error = $wrapper.find('.order_history_additional_customer_error');
    if (!$error.length) {
      $error = $('<span class="error_message order_history_additional_customer_error">');
      $wrapper.append($error);
    }
    $error.text(message);
    orderHistoryUpdateOrderableButtonState();
  }

  function orderHistoryClearCustomerUsageError($input){
    var $wrapper = $input.closest('.order_history_additional_customer_input_wrapper');
    if (!$wrapper.length) {
      return;
    }

    $input.removeClass('order_history_additional_customer_input_error');
    $wrapper.find('.order_history_additional_customer_error').remove();
    $input.closest('.order_history_additional_customer_field').find('.order_history_additional_customer_error').remove();

    var $row = $input.closest('.order_history_additional_customer_row');
    if ($row.length && !$row.find('.order_history_additional_customer_input_error').length) {
      $row.removeClass('has-error');
    }
    orderHistoryUpdateOrderableButtonState();
  }

  // 基幹システム側のSJIS制御文字(Shift-In/Shift-Out)挿入ルールを考慮したバイト数計算
  function orderHistoryCalculateShiftJisBytes(value){
    if (!value) {
      return 0;
    }

    var total = 0;
    var inDoubleByteBlock = false;

    for (var i = 0; i < value.length; i += 1) {
      var char = value.charAt(i);
      var isDoubleByte = orderHistoryIsShiftJisDoubleByteCharacter(char);

      if (isDoubleByte) {
        if (!inDoubleByteBlock) {
          total += 1; // Shift-In
          inDoubleByteBlock = true;
        }
        total += 2; // SJIS 2byte 本体
      } else {
        if (inDoubleByteBlock) {
          total += 1; // Shift-Out
          inDoubleByteBlock = false;
        }
        total += 1; // SJIS 1byte 文字
      }
    }

    if (inDoubleByteBlock) {
      total += 1; // 末尾の Shift-Out
    }

    return total;
  }

  // SJISで2byte扱いとなる文字の判定
  function orderHistoryIsShiftJisDoubleByteCharacter(char){
    if (!char) {
      return false;
    }

    if (/^[\u0000-\u007F]$/.test(char)) {
      return false;
    }

    if (/^[\uFF61-\uFF9F]$/.test(char)) {
      return false;
    }

    return true;
  }

  function toggleAdditionalNoteButtonState(){
    var $addButton = $('#order_history_additional_add_note');
    if (!$addButton.length) {
      return;
    }

    var count = $('#order_history_additional_notes .order_history_additional_note_row').length;
    $addButton.prop('disabled', count >= 6);
  }

  function updateAdditionalNoteIndices(){
    $('#order_history_additional_notes .order_history_additional_note_row').each(function(index, element){
      $(element).find('.order_history_additional_note_index').text(getCircledNumber(index + 1));
    });
  }

  function getCircledNumber(index){
    var circled = ['①', '②', '③', '④', '⑤', '⑥'];
    return circled[index - 1] || index;
  }

  function initDeliveryDestinationModal(){
    var $modal = $('#order_history_delivery_destination_modal');
    if (!$modal.length) {
      return;
    }

    var $modalTitle = $modal.find('.modal-title');
    setupDeliveryDestinationZipAutoFill();
    orderHistoryBindDeliveryDestinationValidations();
    orderHistoryValidateDeliveryDestinationForm();

    $('#order_history_add_delivery_destination_button').on('click', function() {
      resetNewDeliveryDestinationForm();
      $('#order_history_delivery_destination_errors').hide().text('');
      setupDeliveryDestinationZipAutoFill();
      orderHistoryClearDeliveryDestinationErrors();
      orderHistoryUpdateDeliveryDestinationSaveState();
      if ($modalTitle.length) {
        $modalTitle.text('納入先の新規登録');
      }
      $modal.removeData('pendingSuccessMessage');
      $modal.modal('show');
    });

    $('#order_history_edit_delivery_destination_button').on('click', function() {
      var $select = $('#order_history_delivery_destination_select');
      if (!$select.length) {
        return;
      }

      var $selectedOption = $select.find('option:selected');
      if (!$selectedOption.length || !$selectedOption.val()) {
        alert('納入先を選択してください。');
        return;
      }

      resetNewDeliveryDestinationForm();
      $('#order_history_delivery_destination_errors').hide().text('');
      setupDeliveryDestinationZipAutoFill();
      populateDeliveryDestinationModalFromOption($selectedOption);
      orderHistoryClearDeliveryDestinationErrors();
      orderHistoryUpdateDeliveryDestinationSaveState();
      if ($modalTitle.length) {
        $modalTitle.text('納入先の編集');
      }
      $modal.removeData('pendingSuccessMessage');
      $modal.modal('show');
    });

    $('#order_history_save_delivery_destination').on('click', function() {
      submitNewDeliveryDestination();
    });

    $modal.on('hidden.bs.modal', function(){
      resetNewDeliveryDestinationForm();
      $('#order_history_delivery_destination_errors').hide().text('');
      orderHistoryClearDeliveryDestinationErrors();
      orderHistoryUpdateDeliveryDestinationSaveState();
      var message = $modal.data('pendingSuccessMessage');
      if (message) {
        setTimeout(function(){ alert(message); }, 0);
        $modal.removeData('pendingSuccessMessage');
      }
    });
  }

  function resetNewDeliveryDestinationForm(){
    var $form = $('#order_history_new_delivery_destination_form');
    if (!$form.length) {
      return;
    }
    $form.find('input[type="text"]').val('');
    $form.find('input[type="hidden"]').val('');
    orderHistoryClearDeliveryDestinationErrors();
    orderHistoryUpdateDeliveryDestinationSaveState();
  }

  function newDeliveryDestinationParams(){
    return {
      delivery_destination: {
        abbreviation: $('#destination_abbreviation').val(),
        name: $('#destination_name').val(),
        zip1: $('#destination_zip1').val(),
        zip2: $('#destination_zip2').val(),
        address1: $('#destination_address1').val(),
        address2: $('#destination_address2').val(),
        address3: $('#destination_address3').val(),
        tel1: $('#destination_tel1').val(),
        tel2: $('#destination_tel2').val(),
        tel3: $('#destination_tel3').val(),
        fax1: $('#destination_fax1').val(),
        fax2: $('#destination_fax2').val(),
        fax3: $('#destination_fax3').val(),
        delivery_destination_code: $('#destination_code').val()
      }
    };
  }

  // 選択された納入先の間でモーダルの入力欄を埋める
  function populateDeliveryDestinationModalFromOption($option){
    if (!$option || !$option.length) {
      return;
    }

    var fieldMap = [
      { selector: '#destination_abbreviation', dataKey: 'abbreviation' },
      { selector: '#destination_name', dataKey: 'name' },
      { selector: '#destination_zip1', dataKey: 'zip1' },
      { selector: '#destination_zip2', dataKey: 'zip2' },
      { selector: '#destination_address1', dataKey: 'address1' },
      { selector: '#destination_address2', dataKey: 'address2' },
      { selector: '#destination_address3', dataKey: 'address3' },
      { selector: '#destination_tel1', dataKey: 'tel1' },
      { selector: '#destination_tel2', dataKey: 'tel2' },
      { selector: '#destination_tel3', dataKey: 'tel3' },
      { selector: '#destination_fax1', dataKey: 'fax1' },
      { selector: '#destination_fax2', dataKey: 'fax2' },
      { selector: '#destination_fax3', dataKey: 'fax3' }
    ];

    fieldMap.forEach(function(field){
      var $input = $(field.selector);
      if (!$input.length) {
        return;
      }

      var value = $option.data(field.dataKey);
      if (typeof value === 'undefined') {
        var attrName = field.dataKey.replace(/([A-Z])/g, '-$1').toLowerCase();
        value = $option.attr('data-' + attrName);
      }

      if (typeof value === 'undefined' || value === null) {
        value = '';
      }

      $input.val(value);
    });

    var code = $option.data('deliveryDestinationCode');
    if (typeof code === 'undefined') {
      code = $option.attr('data-delivery-destination-code');
    }
    if (typeof code === 'undefined' || code === null) {
      code = '';
    }
    $('#destination_code').val(code);
  }

  function assignOptionDataAttributes($optionElement, data){
    if (!$optionElement || !$optionElement.length || !data) {
      return;
    }

    Object.keys(data).forEach(function(key){
      var value = data[key];
      if (typeof value === 'undefined' || value === null) {
        value = '';
      }

      var hyphenKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      $optionElement.attr('data-' + hyphenKey, value);
      $optionElement.data(key, value);
    });
  }

  function submitNewDeliveryDestination(){
    if (!validateNewDeliveryDestination()) {
      return;
    }

    var params = newDeliveryDestinationParams();
    var $select = $('#order_history_delivery_destination_select');
    var previousOptionValue = $select.length ? $select.val() : null;
    var previousCode = $('#destination_code').val();
    var successMessage = previousCode ? '納入先を更新しました' : '納入先を追加しました';

    $.ajax({
      url: '/quotation_order_histories/create_delivery_destination',
      type: 'post',
      data: params,
      success: function(json) {
        var dest = json.delivery_destination;
        if (!$select.length) {
          return;
        }
        if (!dest || typeof dest.id === 'undefined') {
          return;
        }
        var optionValue = String(dest.id);
        var existingOption = $select.find('option[value="' + optionValue + '"]');
        var optionElement;
        if (existingOption.length) {
          optionElement = existingOption.get(0);
          optionElement.text = dest.abbreviation;
        } else {
          optionElement = new Option(dest.abbreviation, optionValue);
          $select.append(optionElement);
        }

        var $optionElement = $(optionElement);
        var optionData = {
          zip: dest.zip || '',
          address: dest.address || '',
          hasAddress: dest.has_address ? 'true' : 'false',
          abbreviation: dest.abbreviation || '',
          name: dest.name || '',
          zip1: dest.zip1 || '',
          zip2: dest.zip2 || '',
          address1: dest.address1 || '',
          address2: dest.address2 || '',
          address3: dest.address3 || '',
          tel1: dest.tel1 || '',
          tel2: dest.tel2 || '',
          tel3: dest.tel3 || '',
          fax1: dest.fax1 || '',
          fax2: dest.fax2 || '',
          fax3: dest.fax3 || '',
          deliveryDestinationCode: dest.delivery_destination_code || ''
        };
        assignOptionDataAttributes($optionElement, optionData);

        if (previousCode && previousOptionValue && previousOptionValue !== optionValue) {
          $select.find('option[value="' + previousOptionValue + '"]').remove();
        }

        $select.val(optionValue).trigger('change');
        $('#order_history_delivery_destination_modal').data('pendingSuccessMessage', successMessage);
        $('#order_history_delivery_destination_modal').modal('hide');
      },
      error: function(xhr) {
        var errors = (xhr.responseJSON && xhr.responseJSON.errors) ? xhr.responseJSON.errors.join('\n') : '保存に失敗しました。';
        $('#order_history_delivery_destination_errors').text(errors).show();
      }
    });
  }

  function validateNewDeliveryDestination(){
    orderHistoryValidateDeliveryDestinationForm();

    ORDER_HISTORY_DELIVERY_DESTINATION_REQUIRED_SELECTORS.forEach(function(selector){
      var $input = $(selector);
      if ($input.length && (!$input.val() || $input.val().trim() === '')) {
        orderHistoryAddErrorMessage($input, '入力してください。');
      }
    });

    var missingRequired = ORDER_HISTORY_DELIVERY_DESTINATION_REQUIRED_SELECTORS.some(function(selector){
      var $input = $(selector);
      return $input.length && (!$input.val() || $input.val().trim() === '');
    });

    if (missingRequired) {
      $('#order_history_delivery_destination_errors').text('必須項目を入力してください。').show();
      orderHistoryUpdateDeliveryDestinationSaveState();
      return false;
    }

    var faxValues = ORDER_HISTORY_DELIVERY_DESTINATION_FAX_SELECTORS.map(function(selector){
      var $input = $(selector);
      return $input.length ? ($input.val() || '').trim() : '';
    });
    var faxFilledCount = faxValues.filter(function(value){ return value !== ''; }).length;
    var faxIncomplete = faxFilledCount > 0 && faxFilledCount < ORDER_HISTORY_DELIVERY_DESTINATION_FAX_SELECTORS.length;

    if (faxIncomplete) {
      ORDER_HISTORY_DELIVERY_DESTINATION_FAX_SELECTORS.forEach(function(selector){
        var $input = $(selector);
        if ($input.length) {
          orderHistoryAddErrorMessage($input, '全て入力するか、全て空にしてください。');
        }
      });
      $('#order_history_delivery_destination_errors').text('FAX番号は全て入力するか、全て空にしてください。').show();
      orderHistoryUpdateDeliveryDestinationSaveState();
      return false;
    }

    var $form = $('#order_history_new_delivery_destination_form');
    if ($form.length && $form.find('.error_message').length > 0) {
      $('#order_history_delivery_destination_errors').text('入力内容を確認してください。').show();
      orderHistoryUpdateDeliveryDestinationSaveState();
      return false;
    }

    $('#order_history_delivery_destination_errors').hide().text('');
    orderHistoryUpdateDeliveryDestinationSaveState();
    return true;
  }

  function initOrderHistorySelectedDestinationDisplay(){
    var $select = $('#order_history_delivery_destination_select');
    var $summary = $('#order_history_selected_destination_meta');
    var $address = $('#order_history_selected_destination_address');
    var $editButton = $('#order_history_edit_delivery_destination_button');

    if (!$select.length || !$summary.length) {
      return;
    }

    function setEditButtonDisabled(disabled){
      if (!$editButton.length) {
        return;
      }

      $editButton.prop('disabled', disabled);
      if (disabled) {
        $editButton.addClass(ORDER_HISTORY_EDIT_DELIVERY_DISABLED_CLASS);
      } else {
        $editButton.removeClass(ORDER_HISTORY_EDIT_DELIVERY_DISABLED_CLASS);
      }
    }

    function updateSelectedDestination(){
      var value = $select.val();
      if (!value) {
        $summary.css('display', 'none');
        if ($address.length) {
          $address.text('');
        }
        setEditButtonDisabled(true);
        return;
      }

      var $option = $select.find('option[value="' + value + '"]');
      if (!$option.length) {
        $summary.css('display', 'none');
        if ($address.length) {
          $address.text('');
        }
        setEditButtonDisabled(true);
        return;
      }

      var rawZip = $option.data('zip');
      var rawAddress = $option.data('address');
      var zip = rawZip ? String(rawZip).trim() : '';
      var address = rawAddress ? String(rawAddress).trim() : '';
      var hasAddress = $option.data('hasAddress');

      if (typeof hasAddress === 'undefined') {
        hasAddress = zip !== '' && address !== '';
      } else if (typeof hasAddress === 'string') {
        hasAddress = hasAddress === 'true';
      } else {
        hasAddress = !!hasAddress;
      }

      if ($address.length) {
        if (hasAddress && zip && address) {
          $address.text(zip + '　' + address);
        } else {
          $address.text('');
        }
      }

      var optionText = ($option.text() || '').trim();
      var optionAbbreviation = ($option.data('abbreviation') || '').toString();
      var shouldDisableEdit = ORDER_HISTORY_EDIT_DELIVERY_DISABLED_KEYWORDS.some(function(keyword){
        return optionText.indexOf(keyword) !== -1 || optionAbbreviation.indexOf(keyword) !== -1;
      });
      setEditButtonDisabled(shouldDisableEdit);

      $summary.css('display', 'block');
    }

    $select.off('change.orderHistoryDestination').on('change.orderHistoryDestination', updateSelectedDestination);
    updateSelectedDestination();
  }

  function setupDeliveryDestinationZipAutoFill(){
    if (typeof $.fn.jpostal !== 'function') {
      return;
    }

    var $zip1 = $('#destination_zip1');
    var $zip2 = $('#destination_zip2');
    if (!$zip1.length || !$zip2.length) {
      return;
    }

    if (!$zip1.data('jpostal')) {
      $zip1.jpostal({
        postcode: ['#destination_zip1', '#destination_zip2'],
        address: {
          '#destination_address1': '%3%4%5'
        }
      });
    }

    var namespace = '.zipAutoFill';
    $zip1.add($zip2).off(namespace).on('input' + namespace + ' change' + namespace, function() {
      if ($zip1.val().length === 3 && $zip2.val().length === 4) {
        $zip1.trigger('keyup');
      }
    });
  }

  function orderHistoryBindDeliveryDestinationValidations(){
    var $form = $('#order_history_new_delivery_destination_form');
    if (!$form.length) {
      return;
    }

    var namespace = '.orderHistoryDeliveryDestination';

    ORDER_HISTORY_DELIVERY_DESTINATION_FIELD_RULES.forEach(function(rule){
      var $input = $(rule.selector);
      if (!$input.length) {
        return;
      }
      var events = 'input' + namespace + ' keyup' + namespace + ' change' + namespace + ' blur' + namespace;
      $input.off(events).on(events, function(e){
        var $target = $(e.target);
        if (ORDER_HISTORY_DELIVERY_DESTINATION_FULLWIDTH_SELECTORS.indexOf('#' + $target.attr('id')) !== -1) {
          orderHistoryReplaceCharacter($target);
        }
        orderHistoryValidateForm($target, rule);
      });
    });

    Object.keys(ORDER_HISTORY_DELIVERY_DESTINATION_GROUP_RULES).forEach(function(key){
      var definitions = ORDER_HISTORY_DELIVERY_DESTINATION_GROUP_RULES[key];
      var selectors = definitions.map(function(def){ return def.selector; }).join(',');
      if (!selectors) {
        return;
      }

      var events = 'input' + namespace + ' keyup' + namespace + ' change' + namespace + ' blur' + namespace;
      $(selectors).off(events).on(events, function(e){
        var $target = $(e.target);
        if (ORDER_HISTORY_DELIVERY_DESTINATION_NUMERIC_SELECTORS.indexOf('#' + $target.attr('id')) !== -1) {
          orderHistoryNormalizeHalfWidthDigits($target);
        }
        if (ORDER_HISTORY_DELIVERY_DESTINATION_FULLWIDTH_SELECTORS.indexOf('#' + $target.attr('id')) !== -1) {
          orderHistoryReplaceCharacter($target);
        }
        var groupRules = orderHistoryBuildGroupRules(definitions);
        if (groupRules.length) {
          orderHistoryValidateGroup(groupRules);
        } else {
          orderHistoryUpdateDeliveryDestinationSaveState();
        }
      });
    });
  }

  // 納入先モーダルの各項目に応じて保存ボタンの状態を更新
  function orderHistoryValidateDeliveryDestinationForm(){
    ORDER_HISTORY_DELIVERY_DESTINATION_NUMERIC_SELECTORS.forEach(function(selector){
      var $input = $(selector);
      if ($input.length) {
        orderHistoryNormalizeHalfWidthDigits($input);
      }
    });

    ORDER_HISTORY_DELIVERY_DESTINATION_FULLWIDTH_SELECTORS.forEach(function(selector){
      var $input = $(selector);
      if ($input.length) {
        orderHistoryReplaceCharacter($input);
      }
    });

    ORDER_HISTORY_DELIVERY_DESTINATION_FIELD_RULES.forEach(function(rule){
      var $input = $(rule.selector);
      if (!$input.length) {
        return;
      }
      orderHistoryValidateForm($input, rule);
    });

    Object.keys(ORDER_HISTORY_DELIVERY_DESTINATION_GROUP_RULES).forEach(function(key){
      var definitions = ORDER_HISTORY_DELIVERY_DESTINATION_GROUP_RULES[key];
      var groupRules = orderHistoryBuildGroupRules(definitions);
      if (!groupRules.length) {
        return;
      }

      orderHistoryValidateGroup(groupRules);
    });

    orderHistoryUpdateDeliveryDestinationSaveState();
  }

  // 全角数字を半角数字に変換
  function orderHistoryNormalizeHalfWidthDigits($input){
    if (!$input || !$input.length) {
      return;
    }

    var value = $input.val();
    if (typeof value !== 'string') {
      return;
    }

    var replaced = String(value)
      .replace(/[０-９]/g, function(char){
        return String.fromCharCode(char.charCodeAt(0) - 0xFEE0);
      })
      .replace(/[ー−―]/g, '-');

    if (replaced !== value) {
      $input.val(replaced);
    }
  }

  // 半角文字を全角文字に変換する
  function orderHistoryReplaceCharacter($input){
    if (!$input || !$input.length) {
      return;
    }

    var value = $input.val();
    if (typeof value !== 'string' || value === '') {
      return;
    }

    var replaced = String(value).replace(/[!-~]/g, function(char){
      return String.fromCharCode(char.charCodeAt(0) + 0xFEE0);
    });

    if (replaced !== value) {
      $input.val(replaced);
    }
  }

  // 最大長・必須フラグを管理
  function orderHistoryBuildGroupRules(definitions){
    return definitions.map(function(def){
      var $target = $(def.selector);
      if (!$target.length) {
        return null;
      }
      return {
        $target: $target,
        maxLength: def.maxLength,
        isRequired: def.required !== false,
        useBytes: !!def.useBytes
      };
    }).filter(function(rule){ return rule !== null; });
  }

  // 納入先モーダルのエラーチェック
  function orderHistoryValidateForm($target, rule){
    if (!$target || !$target.length) {
      orderHistoryUpdateDeliveryDestinationSaveState();
      return;
    }

    var value = $target.val() || '';
    var maxLength = rule && rule.maxLength;
    var length = orderHistoryGetLength(value, rule && rule.useBytes);

    if (!value) {
      orderHistoryRemoveErrorMessage($target);
    } else if (typeof maxLength === 'number' && length > maxLength) {
      orderHistoryAddErrorMessage($target, '入力した文字が長すぎます。');
    } else if (orderHistoryIncludeUnusableCharacters(value)) {
      orderHistoryAddErrorMessage($target, '入力した文字は使用できません。');
    } else {
      orderHistoryRemoveErrorMessage($target);
    }

    orderHistoryUpdateDeliveryDestinationSaveState();
  }

  // 郵便番号、住所、電話番号、FAX番号のグループ単位でのエラーチェック
  function orderHistoryValidateGroup(groupRules){
    if (!Array.isArray(groupRules) || groupRules.length === 0) {
      orderHistoryUpdateDeliveryDestinationSaveState();
      return;
    }

    var hasLengthError = false;
    var hasUnusableCharError = false;

    groupRules.forEach(function(rule){
      var $target = rule.$target;
      if (!$target.length) {
        return;
      }
      var value = $target.val() || '';
      if (!value) {
        return;
      }
      var limit = typeof rule.maxLength === 'number' ? rule.maxLength : null;
      var length = orderHistoryGetLength(value, rule.useBytes);
      if (limit !== null && length > limit) {
        hasLengthError = true;
      } else if (orderHistoryIncludeUnusableCharacters(value)) {
        hasUnusableCharError = true;
      }
    });

    var errorMessage = null;
    if (hasLengthError) {
      errorMessage = '入力した文字が長すぎます。';
    } else if (hasUnusableCharError) {
      errorMessage = '入力した文字は使用できません。';
    }

    groupRules.forEach(function(rule){
      var $target = rule.$target;
      if (!$target.length) {
        return;
      }
      var value = $target.val() || '';

      if (errorMessage) {
        orderHistoryAddErrorMessage($target, errorMessage);
        return;
      }

      if (value) {
        orderHistoryRemoveErrorMessage($target);
        return;
      }

      var $groupError = $target.closest('.form-group').find('.error_message');
      if ($groupError.length) {
        var currentMessage = $groupError.text();
        if (currentMessage === '入力した文字が長すぎます。' || currentMessage === '入力した文字は使用できません。') {
          orderHistoryRemoveErrorMessage($target);
        }
      }
    });

    orderHistoryUpdateDeliveryDestinationSaveState();
  }


  function orderHistoryIsAllEmpty(inputs){
    if (!Array.isArray(inputs) || inputs.length === 0) {
      return true;
    }
    for (var i = 0; i < inputs.length; i += 1) {
      var $input = inputs[i];
      if (!$input.length) {
        continue;
      }
      var value = $input.val();
      if (value === undefined || value === null) {
        value = '';
      }
      if (value !== '') {
        return false;
      }
    }
    return true;
  }

  function orderHistoryIsAllFilled(inputs){
    if (!Array.isArray(inputs) || inputs.length === 0) {
      return true;
    }
    for (var i = 0; i < inputs.length; i += 1) {
      var $input = inputs[i];
      if (!$input.length) {
        continue;
      }
      var value = $input.val();
      if (value === undefined || value === null) {
        value = '';
      }
      if (value === '') {
        return false;
      }
    }
    return true;
  }


  // 使用できない文字が含まれているかチェックする
  function orderHistoryIncludeUnusableCharacters(str){
    if (str === '' || str === null) {
      return false;
    }
    for (var i = 0; i < UnusableCharacters.length; i += 1) {
      if (str.includes(UnusableCharacters[i])) {
        return true;
      }
    }
    return false;
  }

  function orderHistoryGetLength(value, useBytes){
    if (!value) {
      return 0;
    }
    return useBytes ? orderHistoryCalculateShiftJisBytes(value) : value.length;
  }

  function orderHistoryAddErrorMessage(target, message){
    if (!target || !target.length) {
      return;
    }

    var error_message_element = $('<p class="error_message">').text(message);

    target.addClass('has-error');

    var $formGroup = target.closest('.form-group');
    $formGroup.addClass('has-error');

    var error_message_area = $formGroup.find('.error_message_area');
    if (error_message_area.contents().length === 0) {
      error_message_area.append(error_message_element);
    } else {
      error_message_area.contents().replaceWith(error_message_element);
    }

    orderHistorySyncAddressLabelErrorState();
  }

  function orderHistoryRemoveErrorMessage($input){
    if (!$input || !$input.length) {
      return;
    }

    var $formGroup = $input.closest('.form-group');
    $input.removeClass('has-error');
    $formGroup.removeClass('has-error');
    $formGroup.find('.error_message').remove();

    orderHistorySyncAddressLabelErrorState();
  }

  function orderHistoryClearDeliveryDestinationErrors(){
    var $form = $('#order_history_new_delivery_destination_form');
    if (!$form.length) {
      return;
    }

    $form.find('.error_message').remove();
    $form.find('span.has-error').each(function(){
      var $wrapper = $(this);
      var $children = $wrapper.contents();
      $wrapper.replaceWith($children);
    });
    $form.find('input').removeClass('has-error');
    $form.find('.form-group.has-error').removeClass('has-error');

    orderHistorySyncAddressLabelErrorState();
  }

  function orderHistorySyncAddressLabelErrorState(){
    var $addressGroup = $('#destination_address1').closest('.form-group');
    if (!$addressGroup.length) {
      return;
    }

    var $address3Group = $('#destination_address3').closest('.form-group');

    var hasAddressError = $('#destination_address1, #destination_address2, #destination_address3').toArray().some(function(element){
      var $element = $(element);
      if (!$element.length) {
        return false;
      }
      if ($element.hasClass('has-error')) {
        return true;
      }
      return $element.closest('.form-group').find('.error_message').length > 0;
    });

    if (hasAddressError) {
      $addressGroup.addClass('has-error');
      if ($address3Group.length) {
        $address3Group.addClass('has-error');
      }
    } else {
      $addressGroup.removeClass('has-error');
      if ($address3Group.length) {
        $address3Group.removeClass('has-error');
      }
    }
  }

  // 納入先モーダル全項目の検証と保存ボタン更新をまとめて実行
  function orderHistoryUpdateDeliveryDestinationSaveState(){
    var $form = $('#order_history_new_delivery_destination_form');
    var $saveButton = $('#order_history_save_delivery_destination');
    if (!$form.length || !$saveButton.length) {
      return;
    }

    var shouldDisable = false;

    $form.find('input').each(function(){
      var $input = $(this);
      var value = $input.val();
      var isRequired = $input.data('required') === true;

      if (!isRequired) {
        var selector = '#' + ($input.attr('id') || '');
        if (ORDER_HISTORY_DELIVERY_DESTINATION_REQUIRED_SELECTORS.indexOf(selector) > -1) {
          isRequired = true;
        }
      }

      if ((isRequired && (!value || value === '')) || $input.closest('.form-group').find('.error_message').length > 0) {
        shouldDisable = true;
      }
    });

    var telInputs = [
      $('#destination_tel1'),
      $('#destination_tel2'),
      $('#destination_tel3')
    ];
    if (!(orderHistoryIsAllEmpty(telInputs) || orderHistoryIsAllFilled(telInputs))) {
      shouldDisable = true;
    }

    var faxInputs = [
      $('#destination_fax1'),
      $('#destination_fax2'),
      $('#destination_fax3')
    ];
    if (!(orderHistoryIsAllEmpty(faxInputs) || orderHistoryIsAllFilled(faxInputs))) {
      shouldDisable = true;
    }

    if (shouldDisable) {
      $saveButton.prop('disabled', true);
    } else {
      $saveButton.prop('disabled', false);
      $('#order_history_delivery_destination_errors').hide().text('');
    }
  }

  function parseAdditionalFormDefaults(defaultsData){
    if (!defaultsData) {
      return null;
    }

    if (typeof defaultsData === 'string') {
      try {
        return JSON.parse(defaultsData);
      } catch (e) {
        return null;
      }
    }

    if (typeof defaultsData === 'object') {
      return defaultsData;
    }

    return null;
  }

  function buildAdditionalFormStateFromDefaults(defaults, fallbackState){
    if (!defaults) {
      return null;
    }

    var $form = $('#order_history_additional_form');
    var isImmediateOrder = $form.find('.order_history_additional_delivery_options').length > 0;

    var notesValues = [];
    if (Array.isArray(defaults.notes)) {
      notesValues = defaults.notes.map(function(note){
        return note == null ? '' : note.toString();
      });
    }
    if (notesValues.length === 0) {
      notesValues = [''];
    }

    var values = {
      'order_history_delivery_type': defaults.delivery_type || 'immediate',
      'order_history_delivery_date': defaults.delivery_date || '',
      'order_history_delivery_destination_id': defaults.delivery_destination_id ? defaults.delivery_destination_id.toString() : '',
      'order_history_milsheet_requirement': defaults.milsheet_requirement || 'no_change',
      'order_history_notes[]': notesValues,
      'order_history_additional_customer_note': defaults.customer_order_no1 || '',
      'order_history_additional_customer_note_2': defaults.customer_order_no2 || ''
    };

    if (!isImmediateOrder) {
      values = {
        'order_history_additional_customer_note': defaults.customer_order_no1 || '',
        'order_history_additional_customer_note_2': defaults.customer_order_no2 || ''
      };
      notesValues = [];
    }

    var notesHtml = fallbackState && typeof fallbackState.notesHtml === 'string' ? fallbackState.notesHtml : null;

    return {
      values: values,
      notesValues: notesValues,
      notesHtml: notesHtml
    };
  }

  function captureAdditionalFormState($form){
    if (!$form.length) {
      return null;
    }

    return {
      values: getAdditionalFormValues($form),
      notesHtml: $('#order_history_additional_notes').html()
    };
  }

  function getAdditionalFormValues($form){
    var values = {};
    var isArrayField = /\[\]$/;

    $form.find('input, select, textarea').each(function(){
      var $input = $(this);
      var name = $input.attr('name');
      if (!name || $input.is(':button') || $input.is(':submit')) {
        return;
      }

      var type = ($input.attr('type') || '').toLowerCase();

      if (type === 'radio') {
        if ($input.is(':checked')) {
          values[name] = $input.val();
        } else if (values[name] === undefined) {
          values[name] = null;
        }
        return;
      }

      var value;
      if (type === 'checkbox') {
        value = $input.is(':checked');
      } else {
        value = $input.val();
      }

      if (isArrayField.test(name)) {
        if (!Array.isArray(values[name])) {
          values[name] = [];
        }
        values[name].push(value);
      } else {
        values[name] = value;
      }
    });

    return values;
  }

  function additionalFormHasChanges($form, initialState){
    if (!initialState) {
      return false;
    }

    var currentValues = getAdditionalFormValues($form);
    return !deepEqual(initialState.values, currentValues);
  }

  function deepEqual(valueA, valueB){
    return JSON.stringify(normalizeForComparison(valueA)) === JSON.stringify(normalizeForComparison(valueB));
  }

  function normalizeForComparison(value){
    if (Array.isArray(value)) {
      return value.map(normalizeForComparison);
    }
    if (value && typeof value === 'object') {
      return Object.keys(value).sort().reduce(function(sorted, key){
        sorted[key] = normalizeForComparison(value[key]);
        return sorted;
      }, {});
    }
    return value;
  }

  function resetAdditionalForm($form, initialState){
    if (!initialState) {
      return;
    }

    var values = initialState.values || {};
    var notesHtml = initialState.notesHtml;
    var notesValues = initialState.notesValues;

    if (typeof notesHtml === 'string') {
      var $notesContainer = $('#order_history_additional_notes');
      if ($notesContainer.length) {
        $notesContainer.html(notesHtml);
        $notesContainer.off('input change', '.order_history_additional_note_input');
      }
      $('#order_history_additional_add_note').off('click');
    } else if (Array.isArray(notesValues)) {
      applyAdditionalNoteValues(notesValues);
    }

    $form.find('input, select, textarea').each(function(){
      var $input = $(this);
      var name = $input.attr('name');
      if (!name || $input.is(':button') || $input.is(':submit')) {
        return;
      }
      if (name === 'order_history_notes[]') {
        return;
      }

      var type = ($input.attr('type') || '').toLowerCase();

      if (type === 'radio') {
        var targetRadioValue = values[name];
        $input.prop('checked', $input.val() === targetRadioValue);
      } else if (type === 'checkbox') {
        var checkboxValue = values[name];
        $input.prop('checked', !!checkboxValue);
      } else {
        var targetValue = values[name];
        if (Array.isArray(targetValue)) {
          targetValue = targetValue[0];
        }
        if (targetValue === undefined || targetValue === null) {
          targetValue = '';
        }
        $input.val(targetValue);
        if (!$input.is('select')) {
          $input.attr('value', targetValue);
        }
      }
    });

    if (typeof notesHtml === 'string') {
      initAdditionalNotes();
      toggleAdditionalNoteButtonState();
      $('#order_history_additional_notes .order_history_additional_note_input').each(function(){
        $(this).attr('value', $(this).val());
      });
    } else if (Array.isArray(notesValues)) {
      initAdditionalNotes();
    }

    // リセット時に残っているエラー表示をクリアする
    ['#order_history_additional_customer_note', '#order_history_additional_customer_note_2'].forEach(function(selector){
      var $input = $(selector);
      if ($input.length) {
        orderHistoryClearCustomerUsageError($input);
      }
    });

    $('#order_history_delivery_destination_select').trigger('change');
    $('input[name="order_history_delivery_type"]').trigger('change');
    orderHistoryUpdateOrderableButtonState();
  }

  // ================== 注文確認画面 ==================

  function initializeOrderHistoryConfirmPage(){
    $('#order_history_back_button').on('click', function(e){
      e.preventDefault();
      var backUrl = $(this).data('backUrl');
      if (backUrl) {
        window.location.href = backUrl;
      } else {
        history.back();
      }
    });
  }

  // ================== 注文完了画面 ==================

  function initializeOrderHistoryCompletePage(){
    var beforeHtml = localStorage.getItem('beforeHistoryHtml');
    if (beforeHtml !== null){
      localStorage.removeItem('beforeHistoryHtml');
    }
  }
});
